import React, { useEffect } from 'react';
import { useSearchParams, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { billingAPI } from '../services/api';

const AuthCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { handleAuthCallback } = useAuth();

  useEffect(() => {
    if (location.pathname === '/auth/success') {
      const token = searchParams.get('token');
      const role = searchParams.get('role');
      
      if (token) {
        handleAuthCallback(token, role);
        (async () => {
          try {
            if (role === 'student') {
              const status = await billingAPI.getStatus();
              if (!status.data.hasPaymentMethod) {
                navigate('/student/billing');
                return;
              }
            }

            if (role === 'admin') {
              navigate('/admin');
            } else if (role === 'teacher') {
              navigate('/teacher');
            } else {
              navigate('/student');
            }
          } catch (e) {
            // fallback
            if (role === 'admin') navigate('/admin');
            else if (role === 'teacher') navigate('/teacher');
            else navigate('/student');
          }
        })();
      }
    } else if (location.pathname === '/auth/error') {
      const message = searchParams.get('message');
      console.error('Auth error:', message);
      setTimeout(() => {
        navigate('/login');
      }, 3000);
    }
  }, [searchParams, navigate, location, handleAuthCallback]);

  if (location.pathname === '/auth/error') {
    return (
      <div className="flex-center" style={{ height: '100vh', flexDirection: 'column', gap: '16px' }}>
        <div style={{ fontSize: '48px' }}>❌</div>
        <h2>Login Failed</h2>
        <p className="text-muted">{searchParams.get('message') || 'An error occurred'}</p>
        <p>Redirecting to login page...</p>
      </div>
    );
  }

  return (
    <div className="flex-center" style={{ height: '100vh', flexDirection: 'column', gap: '16px' }}>
      <div className="loading-spinner" style={{ width: '40px', height: '40px' }} />
      <h2>Logging in...</h2>
      <p className="text-muted">Please wait</p>
    </div>
  );
};

export default AuthCallback;
